// extracted by mini-css-extract-plugin
export default {"wrapper":"Header_wrapper__x6b04","sliding-background":"Header_sliding-background__W1-44","title":"Header_title__Tdt0G"};